/* EXP-001 (2026-08-26) — CTA landingu problemowego.
   Native: Shopify Ajax Cart API, POST /cart/add.js z tablica items[].
   Ladowany WYLACZNIE z sekcji christina-concern-ritual. Nie dotyka PDP.

   Trzy zachowania potwierdzone empirycznie 26.08.2026 i obsluzone nizej:
   1. Tiery rabatowe nie maja usesPerOrderLimit -> podwojne klikniecie dodaje protokol
      dwa razy i nalicza rabat dwukrotnie. Stad twarda blokada idempotencji.
   2. Odpowiedz 4xx NIE oznacza, ze nic nie dodano (422 "Tylko N poz. dodano do koszyka
      z powodu dostepnosci" dodaje czesc pozycji). Po KAZDEJ odpowiedzi czytamy /cart.js
      i pokazujemy stan faktyczny, nigdy wlasnej interpretacji.
   3. NIE emitujemy zdarzenia 'cart:refresh'. Motyw podpina pod nie DrawerElement.onCartRefresh,
      ktore probuje otworzyc szuflade koszyka; poza stronami z ta szuflada rzuca
      TypeError "Cannot read properties of null (reading 'open')". Odswiezamy wylacznie
      ikone koszyka przez parametr `sections` w tym samym zadaniu.

   Cena pochodzi wylacznie z Shopify. Front nie liczy rabatu. */
(function () {
  'use strict';

  var ROOT_SEL = '.cc-concern';
  var inflight = false;

  function fmt(cents, unit) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' ' + (unit || 'PLN');
  }

  function statusEl(scope) {
    return scope ? scope.querySelector('[data-cc-status]') : null;
  }

  function setStatus(el, html, state) {
    if (!el) return;
    el.innerHTML = html;
    if (state) { el.setAttribute('data-state', state); } else { el.removeAttribute('data-state'); }
  }

  function busy(btn, on) {
    if (!btn) return;
    if (on) {
      btn.dataset.ccLabel = btn.dataset.ccLabel || btn.textContent.trim();
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      btn.textContent = btn.dataset.ccBusy || 'Dodaję…';
    } else {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      if (btn.dataset.ccLabel) btn.textContent = btn.dataset.ccLabel;
    }
  }

  function refreshBubble(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (typeof html !== 'string') return;
      var host = document.getElementById('shopify-section-' + id) || document.getElementById(id);
      if (!host) return;
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('shopify-section-' + id) || doc.body.firstElementChild;
        if (fresh) host.innerHTML = fresh.innerHTML;
      } catch (e) { /* odswiezenie ikony jest kosmetyczne — nigdy nie przerywa flow */ }
    });
  }

  function report(scope, cart, wanted, partial) {
    var el = statusEl(scope);
    if (!el) return;
    var unit = (scope && scope.dataset.ccMoneyFormat) || 'PLN';
    var have = {};
    (cart.items || []).forEach(function (i) { have[String(i.variant_id)] = i.quantity; });
    var missing = wanted.filter(function (id) { return !have[String(id)]; });

    var parts = ['<strong>W koszyku: ' + fmt(cart.total_price, unit) + '</strong>'];
    if (cart.total_discount > 0) {
      parts.push('Rabat pakietowy: −' + fmt(cart.total_discount, unit) +
                 ' (z ' + fmt(cart.original_total_price, unit) + ')');
    }
    parts.push('<a href="/cart">Przejdź do koszyka</a>');

    if (missing.length) {
      setStatus(el, 'Część produktów nie trafiła do koszyka — sprawdź dostępność. ' + parts.join(' · '), 'error');
    } else if (partial) {
      setStatus(el, parts.join(' · '), 'error');
    } else {
      setStatus(el, parts.join(' · '), null);
    }
  }

  function addItems(scope, btn, items) {
    if (inflight) return;
    inflight = true;
    busy(btn, true);
    setStatus(statusEl(scope), '', null);

    var wanted = items.map(function (i) { return i.id; });
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-icon-bubble' })
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; })
          .then(function (body) { return { ok: res.ok, body: body }; });
      })
      // Zawsze czytamy stan faktyczny koszyka — patrz komentarz nr 2 na gorze pliku.
      .then(function (r) {
        if (r.body && r.body.sections) refreshBubble(r.body.sections);
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (c) { return c.json(); })
          .then(function (cart) { report(scope, cart, wanted, !r.ok); });
      })
      .catch(function () {
        setStatus(statusEl(scope),
          'Nie udało się połączyć z koszykiem. Odśwież stronę i spróbuj ponownie.', 'error');
      })
      .then(function () { inflight = false; busy(btn, false); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cc-add-ritual], [data-cc-add]');
    if (!btn) return;
    var scope = btn.closest(ROOT_SEL);
    if (!scope) return;
    e.preventDefault();

    var items;
    if (btn.hasAttribute('data-cc-add-ritual')) {
      try { items = JSON.parse(btn.getAttribute('data-cc-add-ritual')); } catch (err) { return; }
    } else {
      var id = parseInt(btn.getAttribute('data-cc-add'), 10);
      if (!id) return;
      items = [{ id: id, quantity: 1 }];
    }
    if (!items || !items.length) return;
    addItems(scope, btn, items);
  });
})();
